import { render, staticRenderFns } from "./firefox.vue?vue&type=template&id=b578498a"
import script from "./firefox.vue?vue&type=script&lang=js"
export * from "./firefox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports